module.exports = __webpack_public_path__ + "media/deal-card.714ceeb6.mp3";